import { TestId } from "../testIdType"

export const testId: TestId = {
    allUsersTableSearch: "all-users-table-search",
    inviteUsers: "invite-users",
    userCard: "user-card",
    userProfileForm: "user-profile-form"
}
